<template>
  <QuestionBase :id="db.saveField"
                :errors="[...jsErrors]"
                :question="question"

                :valid="!!data.length">
    <transition name="fade">
      <div class="accordion sub-items">

        <ObjectCard v-for="(liability, index) in data"
                    :id="'liability-other'+index"
                    :key="'liability-other' + liability.id"
                    :ref="'liability-other'+index"
                    v-model="data[index]"
                    :title="`${liability.liabilityType} ${liability.liabilityLender ? liability.liabilityLender : ''}`"
                    type="liability-other"
                    :loading="loading"
                    @delete="deleteObject(liability.id)"
                    @save="saveObject(liability, 'liability-other'+index)">
          <Component :is="formType"
                     :key="'liability-form' + liability.id"
                     v-model="data[index]"
                     :objectId="liability.id" />
        </ObjectCard>

        <ObjectCard v-if="form"
                    ref="liability-other-add"
                    v-model="form"
                    title="Other Liability"
                    type="liability-other-add"
                    :loading="loading"
                    @delete="form=null"
                    @save="saveObject(form, db.saveField)">
          <Component :is="formType"
                     v-model="form"
                     :errors-post="errorsPost"
                     :noSave="true" />
        </ObjectCard>

        <b-button v-if="!form"
                  class="btn-question w-100"
                  @click="add">
          <i class="i-Male-2 text-25 font-weight-800 mr-2"> </i> Add Other
        </b-button>
      </div>
    </transition>
  </QuestionBase>
</template>
<script>
import {objectSaveHelpers} from "../../objects/objectSaveHelpers";
import {questionLoadHelpers} from "../../../helpers/questionLoadHelpers";
import {blankForms} from "../../../helpers/blankForms";

import QuestionBase from "../../../QuestionBase";
import ObjectCard from "../../objects/ObjectCard";
import LiabilityOtherFull from "../../../../fieldsets/sub/liability/LiabilityOtherFull";
import LiabilityOtherEstatePlanning from "../../../../fieldsets/sub/liability/estatePlanning/LiabilityOtherEstatePlanning";
import LiabilityOtherMortgage from "../../../../fieldsets/sub/liability/mortgage/LiabilityOtherMortgage";

export default {
  name: 'LiabilitiesOther',
  components: {
    LiabilityOtherFull,
    LiabilityOtherEstatePlanning,
    LiabilityOtherMortgage,
    ObjectCard,
    QuestionBase
  },
  mixins: [
    objectSaveHelpers,
    questionLoadHelpers,
    blankForms
  ],
  props: {
    value: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'full'
    }
  },
  data() {
    return {
      question: {
        title: null,
        subTitle: null,
        tip: null,
      },
      db: {
        saveLocation: 'client_liability',
        saveField: 'liabilities_other',
        deleteLocation: 'client_liability',
        loadLocation: 'client_liabilities_other',
        syncMultipleObjectOnSave: true,
        fetchObjectsOnSave: false
      },
      args: {
        skippable: false,
        required: true,
        customErrorMessageNewOpenForm: "Save liability before proceeding, by clicking 'confirm'"
      },
      serverErrors: [],
      errorsPost: {},
      jsErrors: [],
      skipped: false,
      form: null,
      errors: {}
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    },
    formType() {
      if (this.type === 'mortgage') return 'LiabilityOtherMortgage'
      if (this.type === 'estatePlanning') return 'LiabilityOtherEstatePlanning'
      return 'LiabilityOtherFull'
    }
  },
  methods: {
    add() {
      this.form = null
      this.form = Object.assign({},
          this.liabilityBlankForm)
    }
  }
}
</script>
